export const environment = {
  production: false,
  baseUrl: 'https://slimmerwerken.app/api-test',
  fileurl: 'https://slimmerwerken.app',
  monitorUrl: 'https://smartbox-solutions.nl/monitor-test',
  testUrl: 'https://slimmerwerken.app/api-test',
  socketUrl: 'https://socket.slimmerwerken.app',
  Deactivate_timer: true
};

/*
export const environment = {
  production: false,
  baseUrl: 'https://192.168.0.197/api',
  fileurl: 'https://192.168.0.197',
  monitorUrl: 'https://192.168.0.197/monitor',
  testUrl: 'https://192.168.0.197/api',
  socketUrl: 'https://192.168.0.197/socket',
  Deactivate_timer: true
};
*/
